import { GridLayout, Box } from '@wishket/design-system';

import PersonalizedContentsSkeleton from '../../PersonalizedContents/parts/Skeleton';

import { Skeleton } from '@/shared/Components';

const PersonalizedAreaSkeleton = () => {
  return (
    <GridLayout>
      <Box className="flex flex-col gap-8 grid-in-content">
        <Box className="flex flex-col gap-3">
          <Skeleton className="h-[40px] w-full rounded-3xl tablet:hidden" />
          <Skeleton className="h-[40px] w-full rounded-3xl desktop:h-[50px]" />
        </Box>
        <PersonalizedContentsSkeleton />
      </Box>
    </GridLayout>
  );
};

export default PersonalizedAreaSkeleton;
